// src/theme/tokens/shadows.js
// Source of truth for Spec + M3 shadow stacks (from Figma)

export const shadows = {
  // M3 Elevation — Light
  m3Light1: '0px 1px 2px rgba(0,0,0,0.3), 0px 1px 3px 1px rgba(0,0,0,0.15)',
  m3Light2: '0px 1px 2px rgba(0,0,0,0.3), 0px 2px 6px 2px rgba(0,0,0,0.15)',
  m3Light3: '0px 4px 8px 3px rgba(0,0,0,0.15), 0px 1px 3px rgba(0,0,0,0.3)',
  m3Light4: '0px 6px 10px 4px rgba(0,0,0,0.15), 0px 2px 3px rgba(0,0,0,0.3)',
  m3Light5: '0px 8px 12px 6px rgba(0,0,0,0.15), 0px 4px 4px rgba(0,0,0,0.3)',

  // M3 Elevation — Dark (black RGBA; good for "real" elevation on dark UI)
  m3Dark1: '0px 1px 3px 1px rgba(0,0,0,0.15), 0px 1px 2px rgba(0,0,0,0.3)',
  m3Dark2: '0px 2px 6px 2px rgba(0,0,0,0.15), 0px 1px 2px rgba(0,0,0,0.3)',
  m3Dark3: '0px 4px 8px 3px rgba(0,0,0,0.15), 0px 1px 3px rgba(0,0,0,0.3)',
  m3Dark4: '0px 6px 10px 4px rgba(0,0,0,0.15), 0px 2px 3px rgba(0,0,0,0.3)',
  m3Dark5: '0px 8px 12px 6px rgba(0,0,0,0.15), 0px 4px 4px rgba(0,0,0,0.3)',

  // Spec Shadows — Light (subtle, "clean")
  specLight1: '0px 1px 2px rgba(0,0,0,0.06), 0px 1px 3px rgba(0,0,0,0.1)',
  specLight2: '0px 2px 4px rgba(0,0,0,0.06), 0px 4px 6px rgba(0,0,0,0.1)',
  specLight3: '0px 10px 15px rgba(0,0,0,0.1), 0px 4px 6px rgba(0,0,0,0.05)',
  specLight4: '0px 20px 25px rgba(0,0,0,0.1), 0px 10px 10px rgba(0,0,0,0.04)',
  specLight5: '0px 25px 50px rgba(0,0,0,0.25)',
  specLightInner: 'inset 0px 2px 4px rgba(0,0,0,0.06)',

  // Spec Shadows — Dark (white RGBA "glow" for overlays on dark UI)
  specDark1: '0px 1px 2px rgba(255,255,255,0.06), 0px 1px 3px rgba(255,255,255,0.1)',
  specDark2: '0px 2px 4px rgba(255,255,255,0.06), 0px 4px 6px rgba(255,255,255,0.1)',
  specDark3: '0px 10px 15px rgba(255,255,255,0.1), 0px 4px 6px rgba(255,255,255,0.05)',
  specDark4: '0px 20px 25px rgba(255,255,255,0.1), 0px 10px 10px rgba(255,255,255,0.04)', // drawers
  specDark5: '0px 25px 50px rgba(255,255,255,0.25)',
  specDarkInner: 'inset 0px 2px 4px rgba(255,255,255,0.06)',
};

